<template>
	<div>
		<div class="text-end mb-3" v-if="isPetugasPresensi">
			<el-button type="info" icon="Plus" plain round @click="dialogCreateVisible = true">Tambah data</el-button>
		</div>
		<el-divider content-position="left" border-style="dotted">Filter</el-divider>
		<el-form :model="logFilter" label-width="auto" label-position="top" :disabled="downloading">
			<el-row :gutter="10" align="middle">
				<el-col :xs="24" :sm="12" :md="10" :xl="7">
					<el-form-item label="Non-GTK" prop="user_presensi_id">
						<el-select v-model="logFilter.user_presensi_id" filterable placeholder="Pilih Non-GTK" clearable>
							<el-option v-for="u in listUser" :key="u.user_presensi_id" :label="u.nama" :value="u.user_presensi_id" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="16" :md="14" :xl="9">
					<el-form-item label="Tanggal" prop="tanggal">
						<el-date-picker
							v-model="logFilter.tanggal"
							type="daterange"
							range-separator="s/d"
							format="DD MMMM YYYY"
							value-format="YYYY-MM-DD"
							start-placeholder="Tanggal Awal"
							end-placeholder="Tanggal Akhir" />
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="8" :md="6" :xl="4">
					<el-form-item label="Mesin Presensi" prop="mesin_presensi_id">
						<el-select v-model="logFilter.mesin_presensi_id" filterable placeholder="Pilih Mesin Presensi" clearable>
							<el-option v-for="m in listMesin" :key="m.mesin_presensi_id" :label="`${m.nama} · ${m.keterangan}`" :value="m.mesin_presensi_id" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="8" :md="6" :xl="4">
					<el-form-item label="Metode Presensi" prop="is_manual">
						<el-select v-model="logFilter.is_manual" placeholder="Pilih Metode Presensi" clearable>
							<el-option label="Via Mesin Presensi" :value="false" />
							<el-option label="Input Manual" :value="true" />
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item v-if="isPetugasPresensi" class="mt-3">
				<el-button @click="downloadLogPresensi" round type="success" icon="Download" class="ms-auto" :loading="downloading">Unduh data riwayat presensi</el-button>
			</el-form-item>
		</el-form>
		<el-divider border-style="dotted" />

		<el-form :model="formEdit" :rules="rulesEdit" @submit.prevent="updateData" ref="formEdit" inline-message :validate-on-rule-change="false">
			<el-table :data="logPresensi" row-key="log_presensi_id" table-layout="auto" v-loading="loading" :cell-class-name="cellClass">
				<template #empty>
					<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" label="No." :index="indexMethod" />
				<el-table-column label="Nama" prop="nama">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="user_presensi_id" v-if="rowEditing === row" class="mb-0">
								<el-select v-model="formEdit.user_presensi_id" filterable :placeholder="row.nama" clearable>
									<el-option v-for="u in listUser" :key="u.user_presensi_id" :label="u.nama" :value="u.user_presensi_id" />
								</el-select>
							</el-form-item>
							<span v-else :key="row.nama" class="text-nowrap">{{ row.nama }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="ID Presensi" prop="user_presensi_id">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Mesin" prop="mesin_presensi_id">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="mesin_presensi_id" v-if="rowEditing === row" class="mb-0">
								<el-select v-model="formEdit.mesin_presensi_id" filterable :placeholder="`${row.nama_mesin} · ${row.ket_mesin}`" clearable>
									<el-option v-for="m in listMesin" :key="m.mesin_presensi_id" :label="`${m.nama_mesin} · ${m.ket_mesin}`" :value="m.mesin_presensi_id" />
								</el-select>
							</el-form-item>
							<span v-else :key="`${row.nama_mesin}_${row.ket_mesin}`" class="text-nowrap">{{ row.nama_mesin }} · {{ row.ket_mesin }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Hari/Tanggal" prop="tanggal_formatted">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="tanggal" v-if="rowEditing === row" class="mb-0">
								<el-date-picker v-model="formEdit.tanggal" type="date" format="DD MMMM YYYY" value-format="YYYY-MM-DD" :placeholder="`${row.tanggal_formatted}`" />
							</el-form-item>
							<span v-else :key="row.tanggal_formatted" class="text-nowrap">{{ row.tanggal_formatted }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Waktu" prop="waktu">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="waktu" v-if="rowEditing === row" class="mb-0">
								<el-time-picker v-model="formEdit.waktu" value-format="HH:mm:ss" :placeholder="row.waktu" />
							</el-form-item>
							<span v-else :key="row.waktu" class="text-nowrap">{{ row.waktu }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Metode" prop="is_manual">
					<template #default="{ row }">
						<el-space size="small" v-if="row.is_manual">
							<el-icon class="text-warning"><EditPen /></el-icon>
							<em>Manual</em>
						</el-space>
						<el-space v-else>
							<el-icon class="text-success"><Monitor /></el-icon>
							<em>Mesin</em>
						</el-space>
					</template>
				</el-table-column>
				<el-table-column label="Tindakan" align="center" v-if="isPetugasPresensi">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<span v-if="row.is_manual === 0">-</span>
							<el-space :spacer="spacer" :size="0" v-else-if="rowEditing === row">
								<el-button type="info" size="small" plain round @click="rowEditing = null">Batal</el-button>
								<el-button type="success" size="small" round native-type="submit" :loading="updating">Simpan</el-button>
							</el-space>
							<el-space :spacer="spacer" :size="0" v-else>
								<el-tooltip content="Edit data">
									<el-button type="primary" size="small" icon="Edit" plain round @click="rowEditing = row" />
								</el-tooltip>
								<el-tooltip content="Hapus data">
									<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
								</el-tooltip>
							</el-space>
						</transition>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				class="flex-wrap justify-content-center mt-3"
				v-model:current-page="currentPage"
				v-model:page-size="pageSize"
				:page-sizes="[5, 10, 25, 50, 100]"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalData"
				@change="getLogPresensi" />
		</el-form>

		<el-form :model="formCreate" :rules="rulesCreate" ref="formCreate" @submit.prevent="insertData" label-width="auto" :disabled="inserting" :validate-on-rule-change="false">
			<el-dialog v-model="dialogCreateVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Tambah Data Presensi" align-center :width="modalWidth">
				<el-form-item prop="user_presensi_id" label="Non-GTK">
					<el-select v-model="formCreate.user_presensi_id" filterable placeholder="Pilih Non-GTK">
						<el-option v-for="u in listUser" :key="u.user_presensi_id" :label="u.nama" :value="u.user_presensi_id" />
					</el-select>
				</el-form-item>
				<el-form-item prop="mesin_presensi_id" label="Mesin Presensi">
					<el-select v-model="formCreate.mesin_presensi_id" filterable placeholder="Pilih Mesin Presensi">
						<el-option v-for="m in listMesin" :key="m.mesin_presensi_id" :label="`${m.nama} · ${m.keterangan}`" :value="m.mesin_presensi_id" />
					</el-select>
				</el-form-item>
				<el-form-item prop="tanggal" label="Tanggal Presensi">
					<el-date-picker v-model="formCreate.tanggal" format="DD MMMM YYYY" value-format="YYYY-MM-DD" placeholder="Tanggal" />
				</el-form-item>
				<el-form-item prop="waktu" label="Waktu Presensi">
					<el-time-picker v-model="formCreate.waktu" value-format="HH:mm:ss" placeholder="Waktu" />
				</el-form-item>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";

export default {
	name: "RiwayatNonGtk",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			logPresensi: [],
			listUser: [],
			dialogCreateVisible: false,
			logFilter: {
				user_presensi_id: null,
				mesin_presensi_id: null,
				tanggal: null,
				is_manual: null,
			},
			formCreate: {
				user_presensi_id: null,
				mesin_presensi_id: null,
				tanggal: null,
				waktu: null,
			},
			rulesCreate: {
				user_presensi_id: [{ required: true, message: "Silakan pilih pengguna", trigger: "change" }],
				mesin_presensi_id: [{ required: true, message: "Silakan pilih mesin presensi", trigger: "change" }],
				tanggal: [{ required: true, message: "Silakan masukkan tanggal presensi", trigger: "change" }],
				waktu: [{ required: true, message: "Silakan masukkan waktu presensi", trigger: "change" }],
			},
			formEdit: {
				user_presensi_id: null,
				mesin_presensi_id: null,
				tanggal: null,
				waktu: null,
			},
			rulesEdit: {
				user_presensi_id: [{ required: false, message: "", trigger: "change" }],
				mesin_presensi_id: [{ required: false, message: "", trigger: "change" }],
				tanggal: [{ required: false, message: "", trigger: "change" }],
				waktu: [{ required: false, message: "", trigger: "change" }],
			},
			rowEditing: null,
			debounceFetch: null,
			loading: true,
			inserting: false,
			updating: false,
			deleting: false,
			downloading: false,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		updateEditing: Function,
		listMesin: Array,
		isPetugasPresensi: Boolean,
		modalWidth: String,
	},
	computed: {
		formEditChanged() {
			if (this.rowEditing) {
				const payload = Object.fromEntries(
					Object.entries(this.formEdit).filter(([key, value]) => {
						const isChanged = value !== this.rowEditing[key];
						const isNotEmpty = value !== "" && value !== null && value !== undefined;

						return isChanged && isNotEmpty;
					}),
				);

				return Object.keys(payload).length > 0;
			}

			return false;
		},
		logFilterClone() {
			return JSON.parse(JSON.stringify(this.logFilter));
		},
	},
	watch: {
		logFilterClone: {
			handler(newVal, oldVal) {
				if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;

				clearTimeout(this.debounceFetch);

				this.debounceFetch = setTimeout(() => {
					if (this.currentPage === 1) this.getLogPresensi();
					else this.currentPage = 1;
				}, 0);
			},
			deep: true,
		},
		formEdit: {
			handler(val) {
				if (val.tanggal || val.waktu) {
					this.rulesEdit = {
						...this.rulesEdit,
						tanggal: [{ required: true, message: "Silakan masukkan tanggal presensi", trigger: "change" }],
						waktu: [{ required: true, message: "Silakan masukkan waktu presensi", trigger: "change" }],
					};
				}
			},
			deep: true,
		},
		formEditChanged(val) {
			this.updateEditing(val);
		},
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
		},
		rowEditing() {
			this.$refs.formEdit.resetFields();
			this.formEdit = {
				user_presensi_id: null,
				mesin_presensi_id: null,
				tanggal: null,
				waktu: null,
			};
		},
	},
	mounted() {
		this.$ws.main.on("log:inserted", this.insertedLog);
		this.$ws.main.on("log:updated", this.updatedLog);
		this.$ws.main.on("log:deleted", this.deletedLog);
		this.$ws.main.on("user:inserted", this.insertedUser);
		this.$ws.main.on("user:updated", this.updatedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.$ws.main.on("mesin:updated", this.updatedMesin);
		this.getLogPresensi();
		this.getListUserPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("log:inserted");
		this.$ws.main.off("log:updated");
		this.$ws.main.off("log:deleted");
		this.$ws.main.off("user:inserted");
		this.$ws.main.off("user:updated");
		this.$ws.main.off("user:deleted");
		this.$ws.main.off("mesin:updated");
	},
	beforeRouteLeave(to, from, next) {
		if (this.formEditChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		isDateInRange(rentangTanggal = [], tanggal) {
			const awal = new Date(rentangTanggal[0] + "T00:00:00+07:00");
			const akhir = new Date(rentangTanggal[1] + "T23:59:59.999+07:00");

			const tanggalData = new Date(tanggal);

			return tanggalData >= awal && tanggalData <= akhir;
		},
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		insertedLog(data) {
			const newData = data;

			if (newData.type !== "non_gtk") return;

			const userFiltered = this.logFilter.user_presensi_id !== null && this.logFilter.user_presensi_id !== "";
			const dateRangeFiltered = Array.isArray(this.logFilter.tanggal);
			const mesinFiltered = this.logFilter.mesin_presensi_id !== null && this.logFilter.mesin_presensi_id !== "";
			const metodeFiltered = this.logFilter.is_manual !== null && this.logFilter.is_manual !== "";

			const newUserMatched = !userFiltered || newData.user_presensi_id === this.logFilter.user_presensi_id;
			const newDateMatched = !dateRangeFiltered || this.isDateInRange(this.logFilter.tanggal, newData.tanggal);
			const newMesinMatched = !mesinFiltered || newData.mesin_presensi_id === this.logFilter.mesin_presensi_id;
			const newMethodMatched = !metodeFiltered || !!newData.is_manual === this.logFilter.is_manual;

			if (userFiltered && !newUserMatched) {
				return;
			}

			if (dateRangeFiltered && !newDateMatched) {
				return;
			}

			if (mesinFiltered && !newMesinMatched) {
				return;
			}

			if (metodeFiltered && !newMethodMatched) {
				return;
			}

			const newMatched = newUserMatched && newDateMatched && newMesinMatched && newMethodMatched;

			if (!newMatched) {
				return;
			}

			const temp = [...this.logPresensi];

			const formttedNewData = {
				...newData,
				tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
			};

			temp.push(formttedNewData);

			temp.sort((a, b) => {
				const scanA = new Date(a.scan);
				const scanB = new Date(b.scan);

				return scanA - scanB;
			});

			const newDataIndex = temp.findIndex((t) => t.log_presensi_id === newData.log_presensi_id);

			if (newDataIndex === this.pageSize) {
				this.totalData++;
				return;
			}

			if (newDataIndex === 0 && this.currentPage > 1) {
				this.getLogPresensi();
				return;
			}

			this.logPresensi.splice(newDataIndex, 0, formttedNewData);

			if (this.logPresensi.length > this.pageSize) this.logPresensi.pop();

			this.totalData++;
		},
		updatedLog(data) {
			const oldData = data.old_log_presensi;
			const newData = data.new_log_presensi;

			if (oldData.type !== "non_gtk" && newData.type !== "non_gtk") return;

			const totalPages = Math.ceil(this.totalData / this.pageSize);

			const userFiltered = this.logFilter.user_presensi_id !== null && this.logFilter.user_presensi_id !== "";
			const dateRangeFiltered = Array.isArray(this.logFilter.tanggal);
			const mesinFiltered = this.logFilter.mesin_presensi_id !== null && this.logFilter.mesin_presensi_id !== "";
			const metodeFiltered = this.logFilter.is_manual !== null && this.logFilter.is_manual !== "";

			const oldUserMatched = !userFiltered || oldData.user_presensi_id === this.logFilter.user_presensi_id;
			const oldDateMatched = !dateRangeFiltered || this.isDateInRange(this.logFilter.tanggal, oldData.tanggal);
			const oldMesinMatched = !mesinFiltered || oldData.mesin_presensi_id === this.logFilter.mesin_presensi_id;
			const oldMethodMatched = !metodeFiltered || !!oldData.is_manual === this.logFilter.is_manual;

			const newUserMatched = !userFiltered || newData.user_presensi_id === this.logFilter.user_presensi_id;
			const newDateMatched = !dateRangeFiltered || this.isDateInRange(this.logFilter.tanggal, newData.tanggal);
			const newMesinMatched = !mesinFiltered || newData.mesin_presensi_id === this.logFilter.mesin_presensi_id;
			const newMethodMatched = !metodeFiltered || !!newData.is_manual === this.logFilter.is_manual;

			if (userFiltered && !oldUserMatched && !newUserMatched) {
				return;
			}

			if (dateRangeFiltered && !oldDateMatched && !newDateMatched) {
				return;
			}

			if (mesinFiltered && !oldMesinMatched && !newMesinMatched) {
				return;
			}

			if (metodeFiltered && !oldMethodMatched && !newMethodMatched) {
				return;
			}

			const oldMatched = oldUserMatched && oldDateMatched && oldMesinMatched && oldMethodMatched;

			const newMatched = newUserMatched && newDateMatched && newMesinMatched && newMethodMatched;

			if (!oldMatched && !newMatched) {
				return;
			}

			if (!oldMatched && newMatched) {
				const temp = [...this.logPresensi];

				const formttedNewData = {
					...newData,
					tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
				};

				temp.push(formttedNewData);

				temp.sort((a, b) => {
					const scanA = new Date(a.scan);
					const scanB = new Date(b.scan);

					return scanA - scanB;
				});

				const newDataIndex = temp.findIndex((t) => t.log_presensi_id === newData.log_presensi_id);

				if (newDataIndex === this.pageSize) {
					this.totalData++;
					return;
				}

				if (newDataIndex === 0 && this.currentPage > 1) {
					this.getLogPresensi();
					return;
				}

				this.logPresensi.splice(newDataIndex, 0, formttedNewData);

				if (this.logPresensi.length > this.pageSize) this.logPresensi.pop();

				this.totalData++;

				return;
			}

			if (oldMatched && !newMatched) {
				const existIndex = this.logPresensi.findIndex((lp) => lp.log_presensi_id === oldData.log_presensi_id);

				if (existIndex !== -1) {
					if (this.rowEditing && this.rowEditing.log_presensi_id === oldData.log_presensi_id) this.rowEditing = null;

					if (this.currentPage === totalPages) {
						this.logPresensi.splice(existIndex, 1);
						this.totalData--;
						return;
					}

					this.getLogPresensi();
					return;
				}

				const temp = [...this.logPresensi];

				temp.push(oldData);

				temp.sort((a, b) => {
					const scanA = new Date(a.scan);
					const scanB = new Date(b.scan);

					return scanA - scanB;
				});

				const oldDataIndex = temp.findIndex((t) => t.log_presensi_id === oldData.log_presensi_id);
				if (oldDataIndex === this.pageSize) {
					this.totalData--;
					return;
				}

				if (oldDataIndex === 0 && this.currentPage === totalPages) {
					this.logPresensi.shift();
					this.totalData--;
					return;
				}

				this.getLogPresensi();
				return;
			}

			if (oldMatched && newMatched) {
				const existIndex = this.logPresensi.findIndex((lp) => lp.log_presensi_id === oldData.log_presensi_id);

				if (existIndex !== -1) {
					if (this.rowEditing && this.rowEditing.log_presensi_id === oldData.log_presensi_id) this.rowEditing = null;

					const tempExists = [...this.logPresensi];

					tempExists[existIndex] = {
						...newData,
						tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
					};

					tempExists.sort((a, b) => {
						const scanA = new Date(a.scan);
						const scanB = new Date(b.scan);

						return scanA - scanB;
					});

					if (this.logPresensi.length < this.pageSize) {
						this.logPresensi = tempExists;
						return;
					}

					const checkIndex = tempExists.findIndex((lp) => lp.log_presensi_id === oldData.log_presensi_id);

					if ((checkIndex === 0 && this.currentPage !== 1) || (checkIndex === this.pageSize - 1 && this.currentPage !== totalPages)) {
						this.getLogPresensi();
						return;
					}

					this.logPresensi = tempExists;

					return;
				}

				const tempOld = [...this.logPresensi];
				const tempNew = [...this.logPresensi];

				tempOld.push(oldData);
				tempNew.push({
					...newData,
					tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
				});

				tempOld.sort((a, b) => {
					const scanA = new Date(a.scan);
					const scanB = new Date(b.scan);

					return scanA - scanB;
				});
				tempNew.sort((a, b) => {
					const scanA = new Date(a.scan);
					const scanB = new Date(b.scan);

					return scanA - scanB;
				});

				const oldDataIndex = tempOld.findIndex((t) => t.log_presensi_id === oldData.log_presensi_id);
				const newDataIndex = tempNew.findIndex((t) => t.log_presensi_id === newData.log_presensi_id);

				if (oldDataIndex === 0) {
					if (newDataIndex === 0) return;

					if (newDataIndex < this.pageSize) {
						tempNew.shift();

						this.logPresensi = tempNew;

						return;
					}
				}

				if (oldDataIndex === this.pageSize) {
					if (newDataIndex === this.pageSize) return;

					if (newDataIndex > 0) {
						tempNew.pop();

						this.logPresensi = tempNew;

						return;
					}
				}

				this.getLogPresensi();
				return;
			}
		},
		deletedLog(data) {
			const oldData = data.old_log_presensi;

			if (oldData.type !== "non_gtk") return;

			const totalPages = Math.ceil(this.totalData / this.pageSize);

			const userFiltered = this.logFilter.user_presensi_id !== null && this.logFilter.user_presensi_id !== "";
			const dateRangeFiltered = Array.isArray(this.logFilter.tanggal);
			const mesinFiltered = this.logFilter.mesin_presensi_id !== null && this.logFilter.mesin_presensi_id !== "";
			const metodeFiltered = this.logFilter.is_manual !== null && this.logFilter.is_manual !== "";

			const oldUserMatched = !userFiltered || oldData.user_presensi_id === this.logFilter.user_presensi_id;
			const oldDateMatched = !dateRangeFiltered || this.isDateInRange(this.logFilter.tanggal, oldData.tanggal);
			const oldMesinMatched = !mesinFiltered || oldData.mesin_presensi_id === this.logFilter.mesin_presensi_id;
			const oldMethodMatched = !metodeFiltered || !!oldData.is_manual === this.logFilter.is_manual;

			if (userFiltered && !oldUserMatched) {
				return;
			}

			if (dateRangeFiltered && !oldDateMatched) {
				return;
			}

			if (mesinFiltered && !oldMesinMatched) {
				return;
			}

			if (metodeFiltered && !oldMethodMatched) {
				return;
			}

			const oldMatched = oldUserMatched && oldDateMatched && oldMesinMatched && oldMethodMatched;

			if (!oldMatched) {
				return;
			}

			const existIndex = this.logPresensi.findIndex((lp) => lp.log_presensi_id === oldData.log_presensi_id);

			if (existIndex !== -1) {
				if (this.rowEditing && this.rowEditing.log_presensi_id === oldData.log_presensi_id) this.rowEditing = null;

				if (this.currentPage === totalPages) {
					this.logPresensi.splice(existIndex, 1);
					this.totalData--;
					return;
				}

				this.getLogPresensi();
				return;
			}

			const temp = [...this.logPresensi];

			temp.push(oldData);
			temp.sort((a, b) => {
				const scanA = new Date(a.scan);
				const scanB = new Date(b.scan);

				return scanA - scanB;
			});

			const oldDataIndex = temp.findIndex((t) => t.log_presensi_id === oldData.log_presensi_id);
			if (oldDataIndex === this.pageSize) {
				this.totalData--;
				return;
			}

			if (oldDataIndex === 0 && this.currentPage === totalPages) {
				this.logPresensi.shift();
				this.totalData--;
				return;
			}

			this.getLogPresensi();
		},
		insertedUser(data) {
			if (data.type !== "non_gtk") return;

			const newData = {
				user_presensi_id: data.user_presensi_id,
				non_gtk_id: data.non_gtk_id,
				nama: data.nama,
			};

			const temp = [...this.listUser];

			temp.push(newData);
			temp.sort((a, b) => {
				return a.nama.localeCompare(b.nama);
			});

			this.listUser = temp;
		},
		updatedUser(data) {
			if (data.type !== "non_gtk") return;

			if (this.logFilter.user_presensi_id === data.old_user_presensi_id) {
				this.logFilter.user_presensi_id = data.old_user_presensi_id;
			}

			this.listUser.every((u) => {
				if (u.user_presensi_id === data.old_user_presensi_id) {
					u.user_presensi_id = data.user_presensi_id;

					return false;
				}
				return true;
			});
			this.logPresensi.forEach((i) => {
				if (i.user_presensi_id === data.old_user_presensi_id) {
					i.user_presensi_id = data.user_presensi_id;
				}
			});
		},
		deletedUser(data) {
			if (data.type !== "non_gtk") return;

			if (this.logFilter.user_presensi_id === data.old_user_presensi_id) {
				this.logFilter.user_presensi_id = null;
			}

			const oldUserIndex = this.listUser.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
			if (oldUserIndex !== -1) this.listUser.splice(oldUserIndex, 1);
		},
		updatedMesin(data) {
			this.logPresensi.forEach((l) => {
				if (l.mesin_presensi_id === data.mesin_presensi_id) {
					l.nama_mesin = data.nama;
					l.ket_mesin = data.keterangan;
				}
			});
		},
		cellClass({ row }) {
			if (this.rowEditing === row) {
				return "align-top";
			}
			return "";
		},
		async getLogPresensi() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.get("/log/index/non-gtk", {
					params: {
						user_presensi_id: this.logFilter.user_presensi_id || undefined,
						mesin_presensi_id: this.logFilter.mesin_presensi_id || undefined,
						is_manual: typeof this.logFilter.is_manual === "boolean" ? this.logFilter.is_manual : undefined,
						tanggal_awal: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[0] : undefined,
						tanggal_akhir: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[1] : undefined,
						page: this.currentPage,
						limit: this.pageSize,
					},
				});

				const logs = data.data.log_presensi.map((l) => ({
					...l,
					tanggal_formatted: new Date(l.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.logPresensi = logs;
				this.totalData = data.data.jumlah_data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		async getListUserPresensi() {
			try {
				const { data } = await this.$defaultApi.get("/user/list/non-gtk");

				this.listUser = data.data.list_user_presensi;
			} catch (error) {
				console.error(error);
			}
		},
		async downloadLogPresensi() {
			this.downloading = true;
			try {
				const { data, headers } = await this.$defaultApi.get("/log/download/non-gtk", {
					params: {
						user_presensi_id: this.logFilter.user_presensi_id || undefined,
						mesin_presensi_id: this.logFilter.mesin_presensi_id || undefined,
						tanggal_awal: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[0] : undefined,
						tanggal_akhir: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[1] : undefined,
					},
					responseType: "blob",
				});

				const contentDisposition = headers["content-disposition"];
				let fileName = "DataRiwayatPresensi.xlsx";

				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						fileName = decodeURIComponent(match[1]);
					}
				}

				const url = window.URL.createObjectURL(new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

				const a = document.createElement("a");
				a.href = url;
				a.download = fileName;
				document.body.appendChild(a);

				await new Promise((resolve) => setTimeout(resolve, 500));
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.downloading = false;
			}
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, [
					"Anda yakin ingin menghapus riwayat presensi ",
					h("strong", row.nama),
					" pada hari ",
					h("strong", new Date(row.scan).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "long" })),
					"?",
				]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteData(row))
				.catch(() => {});
		},
		async insertData() {
			this.inserting = true;
			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.post("/log/", {
					user_presensi_id: this.formCreate.user_presensi_id,
					mesin_presensi_id: this.formCreate.mesin_presensi_id,
					scan: new Date(`${this.formCreate.tanggal}T${this.formCreate.waktu}`),
				});

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.inserting = false;
			}
		},
		async updateData() {
			this.updating = true;
			try {
				if (!this.formEditChanged) {
					throw Error("Anda belum melakukan perubahan");
				}

				const valid = await this.$refs.formEdit.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.patch(`/log/${this.rowEditing.log_presensi_id}`, {
					user_presensi_id: this.formEdit.user_presensi_id || undefined,
					mesin_presensi_id: this.formEdit.mesin_presensi_id || undefined,
					scan: this.formEdit.tanggal && this.formEdit.waktu ? new Date(`${this.formEdit.tanggal}T${this.formEdit.waktu}`) : undefined,
				});

				this.rowEditing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.updating = false;
				}, 500);
			}
		},
		async deleteData(row) {
			this.deleting = true;
			try {
				const { data } = await this.$defaultApi.delete(`/log/${row.log_presensi_id}`);

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
